import React from 'react';
import PropTypes from 'prop-types';

const MergeFieldsSection = ({ clientA, clientB, selectedFields, onFieldSelect }) => {
  const fields = [
    { key: 'firstName', label: 'Imię' },
    { key: 'lastName', label: 'Nazwisko' },
    { key: 'mobile', label: 'Telefon' },
    { key: 'email', label: 'Email' },
    { key: 'address', label: 'Adres' },
    { key: 'invoiceData', label: 'Dane do faktury' },
    { key: 'notes', label: 'Uwagi' },
  ];

  return (
    <div className="merge-fields-section mb-4">
      <h5>Dane klienta</h5>
      <table className="table table-sm">
        <thead>
          <tr>
            <th style={{ width: '20%' }}>Pole</th>
            <th style={{ width: '40%' }}>Klient A (główny)</th>
            <th style={{ width: '40%' }}>Klient B (do usunięcia)</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((field) => {
            const valueA = clientA[field.key] || '(brak)';
            const valueB = clientB[field.key] || '(brak)';
            const selected = selectedFields[field.key] || 'A';
            const valuesDiffer = valueA !== valueB;

            return (
              <tr key={field.key}>
                <td><strong>{field.label}</strong></td>
                <td>
                  {valuesDiffer ? (
                    <>
                      <input
                        type="radio"
                        className="form-check-input me-2"
                        name={field.key}
                        id={`${field.key}-A`}
                        checked={selected === 'A'}
                        onChange={() => onFieldSelect(field.key, 'A')}
                      />
                      <label htmlFor={`${field.key}-A`} className={selected === 'A' ? 'fw-bold text-primary' : ''}>
                        {valueA}
                      </label>
                    </>
                  ) : (
                    <span className="text-muted">{valueA}</span>
                  )}
                </td>
                <td>
                  {valuesDiffer ? (
                    <>
                      <input
                        type="radio"
                        className="form-check-input me-2"
                        name={field.key}
                        id={`${field.key}-B`}
                        checked={selected === 'B'}
                        onChange={() => onFieldSelect(field.key, 'B')}
                      />
                      <label htmlFor={`${field.key}-B`} className={selected === 'B' ? 'fw-bold text-primary' : ''}>
                        {valueB}
                      </label>
                    </>
                  ) : (
                    <span className="text-muted">{valueB}</span>
                  )}
                </td>
              </tr>
            );
          })}
          <tr>
            <td><strong>Umowa</strong></td>
            <td>
              {clientA.hasContract ? '✓ Podpisana' : '✗ Brak'}
            </td>
            <td className="text-muted">
              {clientB.hasContract ? '✓ Podpisana' : '✗ Brak'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

MergeFieldsSection.propTypes = {
  clientA: PropTypes.object.isRequired,
  clientB: PropTypes.object.isRequired,
  selectedFields: PropTypes.object.isRequired,
  onFieldSelect: PropTypes.func.isRequired,
};

export default MergeFieldsSection;
